function scrollToSelector(selector: string) {
  document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function clickSelector(selector: string) {
  (document.querySelector(selector) as HTMLElement | null)?.click();
}

/** Scroll to / activate the matching profile section from `?focus=` query params. */
export function applyUserProfileFocus(focus: string): void {
  switch (focus) {
    case 'profile-photo':
      clickSelector('[data-profile-focus="avatar"]');
      break;
    case 'resume':
      scrollToSelector('[data-profile-focus="resume"]');
      break;
    case 'basics':
      scrollToSelector('[data-profile-focus="basics"]');
      clickSelector('[data-profile-focus="basics-edit"]');
      break;
    case 'languages':
      scrollToSelector('[data-profile-focus="languages"]');
      clickSelector('[data-profile-focus="languages-add"]');
      break;
    case 'work-culture':
      scrollToSelector('[data-profile-focus="work-culture"]');
      clickSelector('[data-profile-focus="work-culture-edit"]');
      break;
    case 'references':
      scrollToSelector('[data-profile-focus="references"]');
      clickSelector('[data-profile-focus="references-add"]');
      break;
    case 'professional-links':
      scrollToSelector('[data-profile-focus="professional-links"]');
      clickSelector('[data-profile-focus="professional-links-add"]');
      break;
    default:
      break;
  }
}
